import { defineMessages } from 'react-intl';

export default defineMessages({
    "awaitingPickup": {
        "defaultMessage": "Awaiting Pickup",
        "id": "src.HomePage.LeftPanelTabs.RideInfoCard.awaitingPickup"
    },
    "addAdmin": {
        "defaultMessage": "Add Admin",
        "id": "src.HomePage.LeftPanelTabs.UserInfoTab.addAdmin.button"
    },
    "addRider": {
        "defaultMessage": "Add Rider",
        "id": "src.HomePage.LeftPanelTabs.UserInfoTab.addRider.button"
    },
    "addUser": {
        "defaultMessage": "Add User",
        "id": "src.HomePage.LeftPanelTabs.UserInfoTab.addUser.button"
    },
    "cancel": {
        "defaultMessage": "Cancel",
        "id": "src.HomePage.LeftPanelTabs.CompanyInfoTab.cancel.button"
    },
    "cancelRide": {
        "defaultMessage": "Cancel Ride",
        "id": "src.HomePage.LeftPanelTabs.RideDetails.cancelRide.button"
    },
    "clickToOpenForm": {
        "defaultMessage": "Click to open form",
        "id": "src.HomePage.LeftPanelTabs.UserInfoCard.clickToOpenForm.label"
    },
    "clickToUploadCsv": {
        "defaultMessage": "Click to bulk upload",
        "id": "src.HomePage.LeftPanelTabs.UserInfoCard.clickToUpload.label"
    },
    "corporateAddress": {
        "defaultMessage": "Corporate Address",
        "id": "src.HomePage.LeftPanelTabs.CompanyInfoTab.corporateAddress.header"
    },
    "driverETA": {
        "defaultMessage": "Driver ETA",
        "id": "src.HomePage.LeftPanelTabs.RideInfoCard.driverETA"
    },
    "driverInfo": {
        "defaultMessage": "Driver Info",
        "id": "src.HomePage.LeftPanelTabs.RideDetails.driverInfo.header"
    },
    "ETA": {
        "defaultMessage": "ETA",
        "id": "src.HomePage.LeftPanelTabs.RideInfoCard.ETA"
    },
    "fare": {
        "defaultMessage": "Fare",
        "id": "src.HomePage.LeftPanelTabs.RideDetails.fare.header"
    },
    "legalCompanyName": {
        "defaultMessage": "Legal Company Name",
        "id": "src.HomePage.LeftPanelTabs.CompanyInfoTab.legalCompanyName.header"
    },
    "logo": {
        "defaultMessage": "Logo",
        "id": "src.HomePage.LeftPanelTabs.CompanyInfoTab.logo.header"
    },
    "noAdminsFound": {
        "defaultMessage": "No admins found.",
        "id": "src.HomePage.LeftPanelTabs.UserInfoTab.noAdminsFound.body"
    },
    "noDriverAssigned": {
        "defaultMessage": "No Driver Assigned",
        "id": "src.HomePage.LeftPanelTabs.RideInfoCard.noDriverAssigned.message"
    },
    "noRidersFound": {
        "defaultMessage": "No riders found.",
        "id": "src.HomePage.LeftPanelTabs.UserInfoTab.noRidersFound.body"
    },
    "noResultsFound": {
        "defaultMessage": "No results found.",
        "id": "src.HomePage.LeftPanelTabs.RideInfoTab.noResultsFound.body"
    },
    "noRidesFound": {
        "defaultMessage": "No rides found.",
        "id": "src.HomePage.LeftPanelTabs.RideInfoTab.noRidesFound.body"
    },
    "noUsersFound": {
        "defaultMessage": "No users found.",
        "id": "src.HomePage.LeftPanelTabs.UserInfoTab.noUsersFound.body"
    },
    "package": {
        "defaultMessage": "Package",
        "id": "src.HomePage.LeftPanelTabs.RideInfoCard.package"
    },
    "primaryContactEmail": {
        "defaultMessage": "Primary Contact Email",
        "id": "src.HomePage.LeftPanelTabs.CompanyInfoTab.primaryContactEmail.header"
    },
    "required": {
        "defaultMessage": "Required",
        "id": "src.HomePage.LeftPanelTabs.CompanyInfoTab.required.errorMessage"
    },
    "rider": {
        "defaultMessage": "Rider",
        "id": "src.HomePage.LeftPanelTabs.RideInfoCard.rider"
    },
    "riders": {
        "defaultMessage": "Riders",
        "id": "src.HomePage.LeftPanelTabs.RideInfoCard.riders"
    },
    "saveInfo": {
        "defaultMessage": "Save Info",
        "id": "src.HomePage.LeftPanelTabs.CompanyInfoTab.saveInfo.button"
    },
    "startAddress": {
        "defaultMessage": "Start Address",
        "id": "src.HomePage.LeftPanelTabs.RideDetails.startAddress.header"
    },
    "endAddress": {
        "defaultMessage": "End Address",
        "id": "src.HomePage.LeftPanelTabs.RideDetails.endAddress.header"
    },
    "packageHeader": {
        "defaultMessage": "Package",
        "id": "src.HomePage.LeftPanelTabs.RideDetails.packageHeader.header"
    },
    "status": {
        "defaultMessage": "Status",
        "id": "src.HomePage.LeftPanelTabs.RideDetails.status.header"
    },
    "search": {
        "defaultMessage": "Search",
        "id": "src.HomePage.LeftPanelTabs.UserInfoTab.search.placeholder"
    },
    "taxIdentifier": {
        "defaultMessage": "Tax ID #",
        "id": "src.HomePage.LeftPanelTabs.CompanyInfoTab.taxIdentifier.header"
    },
    "upcomingRide": {
        "defaultMessage": "Upcoming Ride",
        "id": "src.HomePage.LeftPanelTabs.RideInfoCard.upcomingRide"
    },
    "upload": {
        "defaultMessage": "Upload",
        "id": "src.HomePage.LeftPanelTabs.CompanyInfoTab.upload.button"
    },
    "uploadCsv": {
        "defaultMessage": "Upload Csv",
        "id": "src.HomePage.LeftPanelTabs.UserInfoTab.uploadCsv.button"
    },
});
